export default __webpack_public_path__ + "static/media/pos5.b3fa8772.png";